var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"modal"},[(_vm.room)?_c('div',[_c('Info',{attrs:{"room":_vm.room},on:{"updated":_vm.close}}),(_vm.showSubs)?_c('SubscriberList',{attrs:{"room":_vm.room}}):_vm._e()],1):_c('div',{staticClass:"loading"},[_c('SpinnerIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }